export type PlannerResolvedStatus = 'confirmed' | 'available' | 'maybe' | 'unavailable';

export function normalizePlannerStatus(status: string | null | undefined): PlannerResolvedStatus {
  const normalized = (status || '').trim().toLowerCase();
  if (!normalized || normalized === 'scheduled' || normalized === 'pending') return 'available';
  if (normalized === 'confirmed' || normalized === 'served') return 'confirmed';
  if (normalized === 'declined' || normalized === 'unavailable') return 'unavailable';
  if (normalized === 'maybe') return 'maybe';
  return 'available';
}

export function mergePlannerStatuses(
  current: PlannerResolvedStatus | undefined,
  next: PlannerResolvedStatus
): PlannerResolvedStatus {
  const priority: Record<PlannerResolvedStatus, number> = {
    confirmed: 4,
    unavailable: 3,
    maybe: 2,
    available: 1,
  };

  if (!current) return next;
  return priority[next] > priority[current] ? next : current;
}

export function resolvePlannerServiceStatus(options: {
  assignmentStatus?: string | PlannerResolvedStatus | null;
  availabilityStatus?: string | PlannerResolvedStatus | null;
  hasCalendarBlock: boolean;
}): PlannerResolvedStatus {
  const assignmentStatus =
    options.assignmentStatus == null ? undefined : normalizePlannerStatus(String(options.assignmentStatus));
  const availabilityStatus =
    options.availabilityStatus == null ? undefined : normalizePlannerStatus(String(options.availabilityStatus));

  if (assignmentStatus === 'confirmed') return 'confirmed';
  if (assignmentStatus === 'unavailable') return 'unavailable';
  if (options.hasCalendarBlock) return 'unavailable';
  if (assignmentStatus === 'maybe') return 'maybe';
  if (availabilityStatus === 'unavailable') return 'unavailable';
  if (availabilityStatus === 'maybe') return 'maybe';
  if (assignmentStatus === 'available') return 'available';
  return availabilityStatus ?? 'available';
}

export function formatPlannerStatusLabel(
  status: PlannerResolvedStatus,
  variant: 'service' | 'snapshot' = 'service'
): string {
  if (variant === 'snapshot') {
    if (status === 'confirmed') return 'Confirmed';
    if (status === 'unavailable') return 'Unavailable';
    if (status === 'maybe') return 'Maybe';
    return 'Available';
  }

  if (status === 'confirmed') return 'CONFIRMED';
  if (status === 'unavailable') return 'NOT AVAILABLE';
  return 'AVAILABLE';
}

export function plannerStatusTone(status: PlannerResolvedStatus): 'ok' | 'bad' {
  return status === 'unavailable' ? 'bad' : 'ok';
}